import { ajax } from '@/api/ajax';

export interface SeriesModelListReq {
  lang?: string;
  /**
   * 地区
   */
  region?: string;
}

export interface SeriesListResp {
  /**
   * 车系列表
   */
  seriesList?: SeriesItem[];
}
export interface SeriesItem {
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 车型名称
   */
  modelName?: string;
  /**
   * 车系编码
   */
  seriesCode?: string;
  /**
   * 车系名称
   */
  seriesName?: string;
}

/**
 * @operationId seriesListUsingPOST
 * @tags Toc手册
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-tis-cn-boot/doc.html#/%E6%89%8B%E5%86%8C/Toc%E6%89%8B%E5%86%8C/seriesListUsingPOST
 */
export function seriesListUsingPost(data: SeriesModelListReq) {
  return ajax<SeriesListResp>({
    url: '/api/tis/web/bookmap/seriesList',
    method: 'post',
    data: data
  });
}
